module.exports = __webpack_public_path__ + "img/hit-pract-3.20fe6741.svg";